import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
        image: 'image-1',
        category: 'Agrare Gestor Rural',
        title: 'Plataforma para Gestão de Fazendas'
    },
    {
        image: 'image-7',
        category: 'App Zebu Negócios',
        title: 'Marketplace para Compra e Venda no Agro'
    },
    {
        image: 'image-4',
        category: 'App Pampa S',
        title: 'Portal de Conteúdos Agro do Sicredi'
    },
    {
        image: 'image-5',
        category: 'Carto Mito',
        title: 'Aplicativo para gestão de ligas no Cartola FC'
    },
    {
        image: 'image-3',
        category: 'App Gado Bom',
        title: 'Marketplace para Compra e Venda de Gado'
    },
    {
        image: 'image-2',
        category: 'Protab',
        title: 'Aplicativo para Tabelionatos'
    },
    {
        image: 'image-6',
        category: 'iCode ERP',
        title: 'ERP comercial com gestão completa, tributária e fiscal'
    },
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4><a href="/portfolio-details">{value.title}</a></h4>
                                    {/* <div className="portfolio-button">
                                        <a className="rn-btn" href="/portfolio-details">View Details</a>
                                    </div> */}
                                </div>
                            </div>
                            {/* <Link className="link-overlay" to="/portfolio-details"></Link> */}
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;